var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewScan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.33602C18.72 6.19202 19.44 6.19202 20.16 6.19202C22.392 6.19202 24.552 6.76802 26.424 7.77602",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.352 25.5599C7.416 23.7599 6.84 21.6719 6.84 19.4399C6.84 15.0479 8.928 11.2319 12.168 8.78394",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.536 12.4559C32.76 14.4719 33.48 16.8479 33.48 19.4399C33.48 26.7839 27.504 32.7599 20.16 32.7599C17.568 32.7599 15.192 32.0399 13.176 30.8159",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.16 25.128C23.3014 25.128 25.848 22.5813 25.848 19.44C25.848 16.2986 23.3014 13.752 20.16 13.752C17.0186 13.752 14.472 16.2986 14.472 19.44C14.472 22.5813 17.0186 25.128 20.16 25.128Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.16 3.59998V35.28",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19.4399H4.32",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.376 13.104C31.2847 13.104 32.832 11.5567 32.832 9.64802C32.832 7.73932 31.2847 6.19202 29.376 6.19202C27.4673 6.19202 25.92 7.73932 25.92 9.64802C25.92 11.5567 27.4673 13.104 29.376 13.104Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.368 32.112C12.2767 32.112 13.824 30.5646 13.824 28.656C13.824 26.7473 12.2767 25.2 10.368 25.2C8.45931 25.2 6.912 26.7473 6.912 28.656C6.912 30.5646 8.45931 32.112 10.368 32.112Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44 7.19994H0V1.43994H1.08L3.6 4.46394V1.43994H5.04V7.19994H3.96L1.44 4.17594V7.19994Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.08 7.19994H5.76V1.43994H10.08V2.87994H7.2V5.75994H10.08V7.19994Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.08 3.59998H5.76V5.03998H10.08V3.59998Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.76 7.19994L13.68 5.61594L12.6 7.19994H11.664L10.656 1.43994H12.096L12.672 4.53594L13.68 3.02394L14.256 3.88794L14.688 4.53594L15.264 1.43994H16.704L15.696 7.19994H14.76Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewScan);
export default __webpack_public_path__ + "static/media/newScan.5a38da46b28aad9bfd4761f2ef71ccd8.svg";
export { ForwardRef as ReactComponent };